import Banner from 'commonComponents/banner';
import React, { useEffect } from 'lib/react';
import { EVGrid, EVPaper } from 'lib/components';
import Typography from 'commonComponents/typography';
import { useTranslation } from 'lib/translation';
import { CURRENCY_SYMBOL, SUCCESS } from 'constants/AppConstants';
import Button from 'lib/components/button';
import { useSelector, useDispatch } from 'lib/redux';
import { PAYMENT_OPTIONS, PAYMENT_OPTIONS_INDEX } from 'features/managePaymentOptions/ManagePaymentOptions.constants';
import history from 'store/CreateHistory';
import { ORDER_ROUTE, MANAGE_PAYMENT_OPTIONS_ROUTE } from 'constants/RouteConstants';
import { RESET_UPDATE_ACCOUNT_SUCCESS_RESPONSE_DETAILS } from 'constants/ActionTypes';
import SubmitPaymentOptionStyles from './SubmitPaymentOptionStyles';

function SubmitPaymentSuccess() {
  const classes = SubmitPaymentOptionStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const accountUpdateSuccess = useSelector(({ managePaymentOptions }) => (managePaymentOptions.accountUpdateSuccess));
  useEffect(() => () => dispatch({ type: RESET_UPDATE_ACCOUNT_SUCCESS_RESPONSE_DETAILS }), []);

  if (!accountUpdateSuccess) history.push(MANAGE_PAYMENT_OPTIONS_ROUTE);

  return (
    <>
      <Banner
        severity={SUCCESS}
        message={t('manage_payment__update_account_payment_successful')}
      />
      <EVGrid className={classes.submitPaymentSuccessContainer}>
        <EVPaper className={classes.submitPaymentSuccessPaper}>
          <Typography variant="h3-600" fontColor="ocean-700">{t('manage_payment__payment_option_details')}</Typography>
          <EVGrid className={classes.successPagePaymentOptionValues}>
            <EVGrid className={classes.successPageOptionValue}>
              <Typography
                variant="label-600"
                className={classes.successPageOptionKeyText}
                style={{ textTransform: 'uppercase' }}
              >
                {t('manage_payment__payment_option')}
              </Typography>
              <Typography>{PAYMENT_OPTIONS[PAYMENT_OPTIONS_INDEX[accountUpdateSuccess?.planLevelQualifier]]}</Typography>
            </EVGrid>
            <EVGrid className={classes.successPageOptionValue}>
              <Typography
                variant="label-600"
                className={classes.successPageOptionKeyText}
                style={{ textTransform: 'uppercase' }}
              >
                {t('manage_payment__amount')}
              </Typography>
              <Typography>
                {CURRENCY_SYMBOL[1]}
                {accountUpdateSuccess?.amount}
              </Typography>
            </EVGrid>
            <Button id="order-report-btn" variant="contained" color="primary" className={classes.button} onClick={() => history.push(ORDER_ROUTE)}>
              {t('manage_payment__order_a_report')}
            </Button>
          </EVGrid>
        </EVPaper>
      </EVGrid>
    </>
  );
}

export default SubmitPaymentSuccess;
